import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import GenericModal from '../../../../modal/generic_modal';
import {ForecastTooltipFormulaRenderer} from '../../../../../components/ForecastTooltipFormulaRenderer';
import {ChartStatsContainer, PredictionInfo} from '../predicted_end_date_modal/PredictedEndDateModal.styled';
import PerformanceModalChartSection from './PerformanceModalChartSection';
import {PerformanceModalStatsSection} from './PerformanceModalStatsSection';

const PerformanceModal = ({viewer, performance, warningInfo, closeModal}) => {
	const getContent = () => {
		return (
			<>
				<PredictionInfo>{warningInfo.info}</PredictionInfo>
				<ChartStatsContainer>
					<PerformanceModalStatsSection
						performanceRolling={performance}
						performanceTotal={viewer.project.projectHealth.performanceTotal}
					/>
					<PerformanceModalChartSection performance={performance} projectStats={viewer.project.projectStats} />
				</ChartStatsContainer>
			</>
		);
	};

	const tooltipContent = () => {
		return (
			<ForecastTooltipFormulaRenderer
				items={[
					{
						title: 'Performance tells you how much time your team is spending on finishing tasks compared to your plan. 100% performance means that your tasks are taking exactly the amount of hours to finish as it was estimated. Performance is weighted based on the size of your tasks, meaning large tasks have a bigger impact on performance than small tasks.',
					},
					{
						title: 'Performance:',
						details: ['Task Estimate', '/', 'Time Registered'],
					},
				]}
				translatedMessage={true}
			/>
		);
	};

	return (
		<GenericModal
			closeModal={closeModal}
			content={getContent()}
			headerText={'Performance'}
			headerInfo={tooltipContent()}
			modalWidth={900}
		/>
	);
};

const PerformanceModalQuery = graphql`
	query PerformanceModal_Query($projectId: ID) {
		viewer {
			component(name: "performance_modal")
			actualPersonId
			id
			...PerformanceModal_viewer @arguments(projectId: $projectId)
		}
	}
`;

export {PerformanceModalQuery};

export default createFragmentContainer(PerformanceModal, {
	viewer: graphql`
		fragment PerformanceModal_viewer on Viewer @argumentDefinitions(projectId: {type: "ID"}) {
			project(internalId: $projectId) {
				id
				projectHealth {
					id
					performanceTotal
				}
				projectStats {
					id
					...PerformanceModalChartSection_projectStats
				}
			}
		}
	`,
});
